import * as React from "react";
import { cn } from "../../lib/utils";

const Input = React.forwardRef(
  (
    {
      className,
      type,
      autoComplete,
      leftIcon,
      rightIcon,
      onRightIconClick,
      ...props
    },
    ref,
  ) => {
    // Default to "off" for autocomplete unless explicitly provided
    // This prevents browser autofill on all forms except login
    const autocompleteValue = autoComplete !== undefined ? autoComplete : "off";

    // Determine padding based on icons
    const hasLeftIcon = !!leftIcon;
    const hasRightIcon = !!rightIcon;

    return (
      <div className="relative w-full">
        {/* Left Icon */}
        {hasLeftIcon && (
          <span
            className="absolute left-3.5 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none z-10"
            aria-hidden="true"
          >
            {leftIcon}
          </span>
        )}

        {/* Input Field */}
        <input
          type={type}
          autoComplete={autocompleteValue}
          className={cn(
            "flex h-11 w-full rounded-md border border-input bg-background py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 transition-colors",
            hasLeftIcon ? "pl-11" : "pl-3",
            hasRightIcon ? "pr-11" : "pr-3",
            className,
          )}
          ref={ref}
          {...props}
        />

        {/* Right Icon */}
        {hasRightIcon && (
          <button
            type="button"
            onClick={onRightIconClick}
            className="absolute right-3.5 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors cursor-pointer focus:outline-none focus:text-gray-700 z-10"
            tabIndex={-1}
            aria-label={onRightIconClick ? "Toggle visibility" : undefined}
          >
            {rightIcon}
          </button>
        )}
      </div>
    );
  },
);
Input.displayName = "Input";

export { Input };
